import React, { useState } from "react";
import Form from "react-bootstrap/Form";

import { ProductDetails } from "../../modals/Product";
import { history } from "../../utils/appConfig";
import { MODULES } from "../../utils/routesNames";
import { isValidImageUrl } from "../../utils/common";
import { NO_IMG } from "../../assets/images/images";
import SubstituteProducts from "../SubstituteProducts";
import ListingWidgetAllProducts from "../AddToCartForm/ListingWidgetAllProducts";

const ProductItem: React.FC<ProductDetails> = ({
  name,
  price,
  product_image,
  id,
  category_id,
  out_of_stock,
  product_model,
  units_per_carton,
  allergen_images,
  description,
  rw_price,
  is_cut_off_time_completed
}) => {
  const [image, setImage] = useState(product_image);

  return (
    <div className="product-item-wrapper mb-4 col-xs-12 col-sm-6 col-md-6 col-xl-4">
      <div className="product-item">
        <div className="product-image-container">
          <i className="product-list-item-img">
            <img
              onError={() => setImage(NO_IMG)}
              src={isValidImageUrl(image) ? image : NO_IMG}
              alt={product_image}
            />
          </i>
        </div>
        <div className="product-list-item-detail d-flex flex-column flex-grow-1">
          <div className="w-100 d-flex flex-column flex-grow-1">
            <div className="flex-grow-1">
              <div
                className="label-action"
                onClick={() =>
                  history.push(
                    `${MODULES.allProducts.url}${MODULES.productDetails.url}/${encodeURIComponent(id)}`
                  )
                }
              >
                {product_model && (
                  <p className="product-model">Product Code: {product_model}</p>
                )}
                <span className="product-name-ellipsis" title={name}>{name}</span>
              </div>
              {allergen_images.length > 0 && (
                <div className="d-flex align-items-center flex-wrap mb-3 gap-1">
                  {allergen_images.map((icon, index) => ( 
                      <img
                        key={index}
                        src={icon}
                        alt={`allergen-${index}`}
                        onError={(e) => (e.currentTarget.src = NO_IMG)}
                        className="img-fluid rounded mr-2"
                        style={{ width: "30px", height: "30px", objectFit: "contain" }}
                      />
                    )
                  )}
                </div>
              )}
            </div>
            
            <div className="mt-auto w-100">
              <div className="d-flex mb-3">
                <span>$ {price} {(name.toLowerCase().startsWith("rw") || description.toLowerCase().startsWith("rw")) && "/ 1 Kg"}</span>
                {rw_price && <span className="rw_price ml-4">est. ${rw_price} Pack</span>}
              </div>
              {out_of_stock ? (
                <div className="out-of-stock">
                  {out_of_stock ? "OUT OF STOCK" : ""}
                  <SubstituteProducts id={id} />
                </div>
              ) : (
                ""
              )}
              <Form.Group className="form-group mb-0">
                <ListingWidgetAllProducts
                  id={id}
                  is_saved={0}
                  isListing
                  out_of_stock={out_of_stock}
                  units_per_carton={units_per_carton}
                />
              </Form.Group>
            </div>
          </div>
          {is_cut_off_time_completed && <p className="cutoff-time-message">Today's order cutoff has passed, earliest delivery time is the day after tomorrow</p>}
        </div>
      </div>
    </div>
  );
};

export default ProductItem;
